import React, { Component } from 'react';
import Base from '../../rebase';
import { 
	Carousel
} from 'react-bootstrap';
import PropTypes from 'prop-types';

class ImageCarousel extends Component {

  render() {
  	return (
  		<Carousel responsive="true" Style={"width: 100%;\
      max-height: 600px;\
      max-width: 800px; \
      !important;\
      margin: auto;"
      }>
  			{
  				this.props.items.map((item, index) => (
  				<Carousel.Item>
  					<img width={800} height={600} alt={item.alt} src={item.src}/>
  					<Carousel.Caption>
  						<h3>{item.captionTitle}</h3>
  						<p>{item.captionBody}</p>
  					</Carousel.Caption>
  				</Carousel.Item>
  				))
        }
		</Carousel>
	)
  }
}

export default ImageCarousel;

ImageCarousel.propTypes = {
    items: PropTypes.array.isRequired
}


// WEBPACK FOOTER //
// ./src/reusable_components/page_components/ImageCarousel.jsx